import React, { useState, useCallback, useContext, useEffect } from "react";
import { SocketContext } from "../../contexts/SocketContext";
import { ModalsContext } from "../../contexts/ModalsContext";
import { LoaderContext } from "../../contexts/LoaderContext";
import { AlertContext } from "../../contexts/AlertContext";
import { useParams } from "react-router-dom";
import { convertirLetraMayus } from "../../helpers/convertirLetraMayus";
import { AuthContext } from "../../contexts/AuthContext";
import { Contador } from "../../components/turns/Contador";
import { CreateModuleForm } from "../../components/turns/modules/CreateModuleForm";
import { Actions } from "../../components/turns/modules/Actions";
import { useModalStore } from "../../store/useModalStore";

const columns = [
    { id: 'nombre', label: 'Módulo', minWidth: 100, align: 'center' },
    { id: 'tramites', label: 'Trámites', minWidth: 100, align: 'center' },
    { id: 'estado', label: 'Estado', minWidth: 100, align: 'center' },
    { id: 'acciones', label: 'Acciones', minWidth: 100, align: 'center' },
];

export const useModules = () => {

    const [modules, setModules] = useState([]);
    const { socket } = useContext(SocketContext);
    // const { modalRef } = useContext(ModalsContext);
    const { setOpenLoader } = useContext(LoaderContext);
    const { alertRef } = useContext(AlertContext);
    const { usuario } = useContext(AuthContext);
    const { sede } =  useParams();

    const { openModal, closeModal } = useModalStore();

    useEffect(() => {
        let unsubscribed = true;

        unsubscribed && getModules();

        return () => unsubscribed = false;
    }, [sede]);

    useEffect(() => {
        let unsubscribed = true;

        unsubscribed && refreshModule();

        return () => socket.off('backend:actualizar-modulo');
    }, [modules]);

    // const addModule = () => modalRef.current.handleOpen(<CreateModuleForm action={ saveModule } sede={ sede } />, 500, 600);
    const addModule = () => openModal(<CreateModuleForm action={ saveModule } sede={ sede } />, 600, 'auto');


    const refreshModule = useCallback(() => {
        socket.on('backend:actualizar-modulo', async (response) => {
            const { ok, data: module } = response;

            if(!ok || sede != module?.sede?._id) return;

            const newListModules = modules?.map(m => m.uid == module?.uid ? generatePayload({
                ...module,
                enabled: true
            }) : m);

            setModules(newListModules);
        })
    }, [modules]);

    const getModules = useCallback(() => {
        setOpenLoader(true);
        socket.emit('frontend:consultar-modulo-por-sede', { sede }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef.current.handleOpen('error', message);
                
                return;
            }

            setModules(data?.map(generatePayload));
            setOpenLoader(false);
        });
    }, [sede]);

    const saveModule = async (data) => {
        setOpenLoader(true);
        // const { name, sede, ...rest} = data;
        const { name, sede, tramites } = data;

        const payload = {
            nombre: name.toLowerCase(),
            sede,
            tramites
            //tramites: Object.values(rest)
        }

        socket.emit('frontend:crear-modulo', payload, async response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current.handleClose();
                closeModal();
                alertRef.current.handleOpen('error', message);
                return;
            }

            setModules(prev => ([...prev, generatePayload(data)]));
            // modalRef.current.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const updateModule = (params) => {
        setOpenLoader(true);

        const { id, tramits: tramites } = params;
        
        const payload = {
            // tramites: Object.values(tramits),
            tramites,
            id,
            usuario
        }

        socket.emit('frontend:actualizar-modulo', payload, async response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current.handleClose();
                closeModal();
                alertRef.current.handleOpen('error', message);
                return;
            }

            setModules(prev => prev?.map(p => p?.uid === id ? generatePayload(data) : p ));
            // modalRef.current.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const deleteModule = async (id) => {
        setOpenLoader(true);
        socket.emit('frontend:eliminar-modulo', { id }, async response => {
            const { ok, message } = response;

            if(!ok) {
                // modalRef.current.handleClose();
                closeModal();
                setOpenLoader(false);
                alertRef.current.handleOpen('error', message);
                return;
            }
          
            setModules(prev => prev?.filter(module => module.uid !== id));
            // modalRef.current.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const generatePayload = (data) => ({
        ...data,
        nombre: convertirLetraMayus(data?.nombre),
        tramites: data?.tramites?.join(' - ').toUpperCase(),
        estado: convertirLetraMayus(data?.estatus),
        acciones: <Actions data={ data } updated={ updateModule } deleted={ deleteModule } />
    });

	return {
        columns,
        modules,
        addModule
    }
}